import { useMemo } from 'react';
import { FindOrCreateDraftJob } from '@common/hooks/job/useFindOrCreateDraftForRepost';
import { BusinessWithUsers } from '@store/entities/businesses/types';
import { FormData } from '../RepostJob';
import { toPostJobFormData } from '../transformers/draft/toPostJobFormData';
import { useDraftBusiness } from './useDraftBusiness';

export const useMapDraftToFormData = (
  draft: FindOrCreateDraftJob,
  businesses: BusinessWithUsers[]
): FormData => {
  const business = useDraftBusiness(businesses, draft?.businessId);

  return useMemo(() => toPostJobFormData(draft, business), [draft, business]);
};
